const fetchCurrentDate = () => {
  const req = new XMLHttpRequest();
  req.open('GET', window.location.href, false);
  req.send(null);
  const headers = req.getAllResponseHeaders()
    .toLowerCase()
    .split('date')[1];
  const currentDate =  headers.split('gmt')[0]
    .substring(7, 19);
  return new Date(currentDate);
};

const monthsMapping: any = {
  Jan : '01',
  Feb : '02',
  Mar : '03',
  Apr : '04',
  May : '05',
  Jun : '06',
  Jul : '07',
  Aug : '08',
  Sep : '09',
  Oct : '10',
  Nov : '11',
  Dec : '12',
};

// Wed Dec 29 2021
const formatDate = (value: string) => {
  const parsedDate = value.split(' ');
  const date = `${parsedDate[2]}/${monthsMapping[parsedDate[1]]}/${parsedDate[3]}`;
  return date;
};

const FILTER_TYPES: string[] = ['serialList', 'tenantsList', 'usersList', 'sourceList'];
const CUSTOMIZED_COLUMNKEYS: string[] = ['activityOrganization', 'ipAddress'];
const RADIO_LISTS: string[] = ['serialList', 'tenantsList', 'activityIpList'];
const LARGE_CUSTOMER_LISTS: string[] = ['serialList', 'tenantsList',  'usersList'];
const LARGE_CUSTOMER_REQUEST_PARAMS :{[property: string]: string } = {
  tenantsList: 'tenant',
  usersList: 'emailAddress',
  serialList: 'serialNumber',
};

interface ActivtyData {
  tableHeader: string;
  colList: string[];
  tableData: string[];
}

const TABLE_HEADER_HEIGHT = 30;
const TABLE_ROW_HEIGHT_NORMAL = 40;
const TABLE_ROW_HEIGHT_MAX = 80;

export {
  fetchCurrentDate,
  ActivtyData,
  formatDate,
  FILTER_TYPES,
  CUSTOMIZED_COLUMNKEYS,
  RADIO_LISTS,
  LARGE_CUSTOMER_LISTS,
  LARGE_CUSTOMER_REQUEST_PARAMS,
  TABLE_ROW_HEIGHT_MAX,
  TABLE_ROW_HEIGHT_NORMAL,
  TABLE_HEADER_HEIGHT,
};
